<template>
  <div class="btn-news">
    <a
      href="https://www.facebook.com/pocketcurator/"
      target="_blank">
      <i class="icon-facebook"/>
      {{ textData[lang.key].btnNews.text }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BtnNews',
  components: {
    mapGetters
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['textData', 'lang'])
  },
  methods: {
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="postcss" scoped>
  .btn-news {
    & a {
      display: inline-block;
      font-size: 14px;
      & .icon-facebook {
        display: inline-block;
        width: 24px;
        height: 24px;
        vertical-align: top;
        margin-right: 10px;
        background: url('~@/assets/img/icon-facebook.png');
        background-size: 24px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/BtnNews.vue